/* 🤖 this file was generated by svg-to-ts */
export const siriusCloudArrowUp: {
  name: 'cloud_arrow_up';
  data: string;
} = {
  name: 'cloud_arrow_up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M13.982 5.327A6.75 6.75 0 0 1 20.4 16.05a.75.75 0 1 0 1.2.9 8.252 8.252 0 0 0-7.844-13.106A8.25 8.25 0 0 0 7.62 8.312a6 6 0 1 0-.87 11.938H9a.75.75 0 0 0 0-1.5H6.75a4.5 4.5 0 1 1 .31-8.99A8.25 8.25 0 0 0 6.75 12a.75.75 0 0 0 1.5 0 6.75 6.75 0 0 1 5.732-6.673Z" fill="currentColor"/><path d="M14.527 11.303c.092.036.179.092.253.167l3.179 3.178a.75.75 0 0 1-1.061 1.06L15 13.812V19.5a.75.75 0 0 1-1.5 0v-5.69l-1.898 1.899a.75.75 0 0 1-1.06-1.061l3.174-3.175a.747.747 0 0 1 .81-.17Z" fill="currentColor"/></svg>`
};
